import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { formatRupiah } from "../lib/format";

export const AmountInput = ({ value, onChange, testId = "amount-input", placeholder = "0" }) => {
  const display = value ? Number(value).toLocaleString("id-ID") : "";
  return (
    <div className="relative">
      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground font-semibold">Rp</span>
      <Input
        data-testid={testId}
        className="pl-12 h-14 text-xl font-semibold tabular-nums rounded-xl"
        inputMode="numeric"
        placeholder={placeholder}
        value={display}
        onChange={(e) => {
          const raw = e.target.value.replace(/\D/g, "");
          onChange(raw ? parseInt(raw, 10) : 0);
        }}
      />
    </div>
  );
};

export const QuickAmounts = ({ onPick, amounts = [50000, 100000, 250000, 500000] }) => (
  <div className="flex flex-wrap gap-2">
    {amounts.map((a) => (
      <Button
        key={a}
        type="button"
        variant="outline"
        size="sm"
        className="rounded-full text-xs"
        onClick={() => onPick(a)}
        data-testid={`quick-amount-${a}`}
      >
        {formatRupiah(a)}
      </Button>
    ))}
  </div>
);
